import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 管理员
export default {
  getAdminList(params) { // 管理员用户列表
    const url =  baseURL + '/tbAdminuser/list';
    return axios.post(url, qs.stringify(params));
  },
  setAdmin(params) { // 新增管理员
    const url =  baseURL + '/tbAdminuser/addAdminUser';
    return axios.post(url, qs.stringify(params));
  },
  delAdmin(params) { // 删除管理员
    const url =  baseURL + '/tbAdminuser/delete';
    return axios.post(url, qs.stringify(params));
  },
  editAdmin(params) { // 重置管理员用户密码
    const url =  baseURL + '/tbAdminuser/adminUserPasswordReset';
    return axios.post(url, qs.stringify(params));
  },
  loginAdmin(params){// 管理员登录
    const url =  baseURL + '/tbAdminuser/adminUserlogin';
    return axios.post(url, qs.stringify(params));
  },
  
}


// WEBPACK FOOTER //
// ./src/api/admin.js